<template>
  <q-card
    flat bordered
  >
    <q-card-section
        class="q-pa-sm row justify-between items-center bg-primary text-white text-bold"
    >
      Timesheet
    </q-card-section>
    <q-separator />
    <q-card-section>
      <strong>Employee Name : </strong> {{employeeName}}
        <div class="q-pt-sm">
          <q-btn
            :color="otherState.color"
            :label="otherState.label"
            :icon="otherState.icon" @click="switchTimeTracker"
            :icon-right="otherState.iconright"
          />
          <app-clock-elapsed-time ref="stopwatch"/>
        </div>
        <!-- <q-btn color="brand1" label="Break" icon="timer" /> -->
    </q-card-section>
  </q-card>
</template>
<script>
import graphql from '@client/graphql';
import { EmployeeActivityState } from '@client/constants/employee-activity.ts';
import AppTimeTracker from '@client/utils/app-time-tracker';
import { updateCurrentEmployeeActivityTypeStoreCache } from '@client/utils/app-helpers';
import AppClockElapsedTime from './clock-elapsed-time';

const states = {
  work: {
    color: 'brand2',
    label: 'Clock In',
    icon: 'alarm_on',
    iconright: 'play_circle'
  },
  break: {
    color: 'brand4',
    label: 'Clock Out',
    icon: 'alarm_off',
    iconright: 'stop_circle'
  }
};

export default {
  name: 'AppClockTimesheet',
  components: {
    AppClockElapsedTime
  },
  props: {
    currentUser: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    employeeName() {
      return `${this.currentUser?.firstName} ${this.currentUser?.lastName}`;
    },
    otherState() {
      return this.isActive ? states.break : states.work;
    }
  },
    apollo: {
    currentEmployeeActivityType: {
      query: graphql.queries.currentEmployeeActivityType,
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      skip() {
        return this.skipQuery;
      },
      result(result) {
        this.isActive = result?.data?.currentEmployeeActivityType === EmployeeActivityState.WORK;
        if (!this.isActive) {
            this.$refs.stopwatch.reset();
        }
      }
    }
  },
  data() {
    return {
      isActive: false,
      skipQuery: true,
      isLoading: true
    };
  },
  async mounted() {
    this.skipQuery = false;
  },

  methods: {
    async switchTimeTracker() {
      const response = await this.$apollo.mutate({
        mutation: graphql.mutations.switchEmployeeActivity,
        variables: {
          activity: this.isActive ? EmployeeActivityState.BREAK : EmployeeActivityState.WORK
        },
        update: (store, { data: { switchEmployeeActivity: { activity, isSwitchedActivity } } }) => {
                if (isSwitchedActivity) {
                  updateCurrentEmployeeActivityTypeStoreCache(store, activity);
                }
            }
      });
      if (response?.data?.switchEmployeeActivity?.activity) {
        this.isActive = response?.data?.switchEmployeeActivity?.activity
        === EmployeeActivityState.WORK;
        if (this.isActive) {
          this.$refs.stopwatch.start();
          AppTimeTracker.start();
        } else {
          this.$refs.stopwatch.reset();
          AppTimeTracker.stop();
        }
      }
    }
  }
};
</script>
<style lang="scss">
</style>
